import React, {CSSProperties} from 'react';
import Icon from '@ant-design/icons';
import {ReactComponent as menuUnfold} from './svg/menuUnfold.svg';
import {ReactComponent as user} from './svg/user.svg';
import {ReactComponent as ellipsis} from './svg/ellipsis.svg';
import { ReactComponent as dir } from './svg/dir.svg';
import { ReactComponent as dirActive } from './svg/dirActive.svg';
import { ReactComponent as dirExpand } from './svg/dirExpand.svg';
import { ReactComponent as dirExpandActive } from './svg/dirExpandActive.svg';
import { ReactComponent as dirOutline } from './svg/dirOutline.svg';
import { ReactComponent as expand } from './svg/expand.svg';
import { ReactComponent as packUp } from './svg/packUp.svg';
import { ReactComponent as file } from './svg/file.svg';
import { ReactComponent as fileActive } from './svg/fileActive.svg';
import { ReactComponent as plus } from './svg/plus.svg';
import { ReactComponent as search } from './svg/search.svg';
import { ReactComponent as more } from './svg/more.svg';
import { ReactComponent as arrowLeft } from './svg/arrowLeft.svg';
import { ReactComponent as warn } from './svg/warn.svg';
import { ReactComponent as img } from './svg/img.svg';
import { ReactComponent as checked } from './svg/checked.svg';
import { ReactComponent as imgOutline } from './svg/imgOutline.svg';
import { ReactComponent as imgUploadOutline } from './svg/imgUploadOutline.svg';
import { ReactComponent as eyes } from './svg/eyes.svg';
import { ReactComponent as editOutline } from './svg/editOutline.svg';

import { ReactComponent as major } from './svg/major.svg';
import { ReactComponent as architecture } from './svg/architecture.svg';
import { ReactComponent as structure } from './svg/structure.svg';
import { ReactComponent as electric } from './svg/electric.svg';
import { ReactComponent as wad } from './svg/wad.svg';
import { ReactComponent as hvac } from './svg/hvac.svg';
import { ReactComponent as sortHandle } from './svg/sortHandle.svg';
import { ReactComponent as sort } from './svg/sort.svg';

import { ReactComponent as file2 } from './svg/file2.svg';
import { ReactComponent as file3 } from './svg/file3.svg';
import { ReactComponent as edit } from './svg/edit.svg';
import { ReactComponent as group } from './svg/group.svg';
import { ReactComponent as fileAdd } from './svg/fileAdd.svg';
import { ReactComponent as edit2 } from './svg/edit2.svg';
import { ReactComponent as remove } from './svg/remove.svg';
import { ReactComponent as packupLeft } from './svg/packupLeft.svg';
import { ReactComponent as tips } from './svg/tips.svg';
import { ReactComponent as desc } from './svg/desc.svg';
import { ReactComponent as connect } from './svg/connect.svg';
import { ReactComponent as invalidFile } from './svg/invalidFile.svg';
import { ReactComponent as expandAll } from './svg/expandAll.svg';
import { ReactComponent as expandNone } from './svg/expandNone.svg';
import { ReactComponent as file4 } from './svg/file4.svg';
import { ReactComponent as book } from './svg/book.svg';
import { ReactComponent as alert } from './svg/alert.svg';
import { ReactComponent as bookmark } from './svg/bookmark.svg';
import { ReactComponent as bookmarkFilled } from './svg/bookmarkFilled.svg';
import { ReactComponent as leftArrow } from './svg/leftArrow.svg';
import { ReactComponent as rightArrow } from './svg/rightArrow.svg';
import { ReactComponent as category } from './svg/category.svg';
import { ReactComponent as order } from './svg/order.svg';
import { ReactComponent as question } from './svg/question.svg';
import { ReactComponent as questionFilled } from './svg/questionFilled.svg';
import { ReactComponent as back } from './svg/back.svg';
import { ReactComponent as exclamation } from './svg/exclamation.svg';
import { ReactComponent as backLeft } from './svg/backLeft.svg';
import { ReactComponent as clear } from './svg/clear.svg';
import { ReactComponent as favorite } from './svg/favorite.svg';
import { ReactComponent as like } from './svg/like.svg';
import { ReactComponent as heart } from './svg/heart.svg';
import { ReactComponent as comment } from './svg/comment.svg';
import { ReactComponent as circleArrow } from './svg/circleArrow.svg';
import { ReactComponent as switchIcon } from './svg/switch.svg';
import { ReactComponent as alarm } from './svg/alarm.svg';

import { ReactComponent as auditPass } from './svg/audit-pass.svg';
import { ReactComponent as auditPause } from './svg/audit-pause.svg';
import { ReactComponent as auditPublish } from './svg/audit-publish.svg';
import { ReactComponent as auditRefuse } from './svg/audit-refuse.svg';
import { ReactComponent as auditRollback } from './svg/audit-rollback.svg';
import { ReactComponent as auditSubmit } from './svg/audit-submit.svg';
import { ReactComponent as auditUsers } from './svg/audit-users.svg';

import { ReactComponent as clock } from './svg/clock.svg';
import { ReactComponent as flag } from './svg/flag.svg';
import { ReactComponent as formEdit } from './svg/formEdit.svg';
import { ReactComponent as refuse } from './svg/refuse.svg';
import { ReactComponent as seal } from './svg/seal.svg';
import { ReactComponent as trash } from './svg/trash.svg';
import { ReactComponent as list } from './svg/list.svg';
import { ReactComponent as listOutline } from './svg/listOutline.svg';
import { ReactComponent as listBold } from './svg/listBold.svg';

import { ReactComponent as commentOutline } from './svg/commentOutline.svg';
import { ReactComponent as likeOutline } from './svg/likeOutline.svg';
import { ReactComponent as heartOutline } from './svg/heartOutline.svg';

import { ReactComponent as userFilled } from './svg/userFilled.svg';
import { ReactComponent as userOutline } from './svg/userOutline.svg';
import { ReactComponent as addUser } from './svg/addUser.svg';
import { ReactComponent as checkOutline } from './svg/checkOutline.svg';
import { ReactComponent as foot } from './svg/foot.svg';

import { ReactComponent as house } from './svg/house.svg';
import { ReactComponent as org } from './svg/org.svg';

import { ReactComponent as judgement } from './svg/judgement.svg';
import { ReactComponent as checkbox } from './svg/checkbox.svg';
import { ReactComponent as radio } from './svg/radio.svg';

import { ReactComponent as correct } from './svg/correct.svg';
import { ReactComponent as error } from './svg/error.svg';

import { ReactComponent as examList } from './svg/examList.svg';
import { ReactComponent as switch2 } from './svg/switch2.svg';
import { ReactComponent as errorCheckbox } from './svg/errorCheckbox.svg';
import { ReactComponent as examListAdd } from './svg/examListAdd.svg';
import { ReactComponent as listAdd } from './svg/listAdd.svg';
import { ReactComponent as examListActive } from './svg/examListActive.svg';
import { ReactComponent as normalConnect } from './svg/normalConnect.svg';
import { ReactComponent as multiple } from './svg/multiple.svg';

import { ReactComponent as largeSize } from './svg/largeSize.svg';
import { ReactComponent as middleSize } from './svg/middleSize.svg';
import { ReactComponent as miniSize } from './svg/miniSize.svg';
import { ReactComponent as fullScreen } from './svg/fullScreen.svg';

import { ReactComponent as flagFilled } from './svg/flagFilled.svg';
import { ReactComponent as navFilled } from './svg/navFilled.svg';
import { ReactComponent as bookFilled } from './svg/bookFilled.svg';

import { ReactComponent as eyeFilled } from './svg/eyeFilled.svg';
import { ReactComponent as controlFilled } from './svg/controlFilled.svg';
import { ReactComponent as control } from './svg/control.svg';
import { ReactComponent as download } from './svg/download.svg';
import { ReactComponent as scrollTop } from './svg/scrollTop.svg';
import { ReactComponent as addUserFilled } from './svg/addUserFilled.svg';
import { ReactComponent as edit3 } from './svg/edit3.svg';
import { ReactComponent as multipleBook } from './svg/multipleBook.svg';
import { ReactComponent as buildingFilled } from './svg/buildingFilled.svg';
import { ReactComponent as homeFilled } from './svg/homeFilled.svg';
import { ReactComponent as personFilled } from './svg/personFilled.svg';
import { ReactComponent as mouse } from './svg/mouse.svg';


interface IconProps {
	className?: string;
	style?: CSSProperties;
	title?: any;
	onClick?: any;
}


// 菜单收起
export const MenuUnfoldIcon = (props: IconProps) => <Icon component={menuUnfold} {...props} />
// 用户
export const UserIcon = (props: IconProps) => <Icon component={user} {...props} />
// 省略号
export const EllipsisIcon = (props: IconProps) => <Icon component={ellipsis} {...props} />


export const DirIcon = (props: IconProps) => <Icon component={dir} {...props} />
export const DirActiveIcon = (props: IconProps) => <Icon component={dirActive} {...props} />
export const DirExpandIcon = (props: IconProps) => <Icon component={dirExpand} {...props} />
export const DirExpandActiveIcon = (props: IconProps) => <Icon component={dirExpandActive} {...props} />
export const DirOutlineIcon = (props: IconProps) => <Icon component={dirOutline} {...props} />
export const ExpandIcon = (props: IconProps) => <Icon component={expand} {...props} />
export const PackUpIcon = (props: IconProps) => <Icon component={packUp} {...props} />
export const FileIcon = (props: IconProps) => <Icon component={file} {...props} />
export const FileActiveIcon = (props: IconProps) => <Icon component={fileActive} {...props} />
export const PlusIcon = (props: IconProps) => <Icon component={plus} {...props} />
export const SearchIcon = (props: IconProps) => <Icon component={search} {...props} />
export const MoreIcon = (props: IconProps) => <Icon component={more} {...props} />
export const ArrowLeft = (props: IconProps) => <Icon component={arrowLeft} {...props} />
export const WarnIcon = (props: IconProps) => <Icon component={warn} {...props} />
export const ImgIcon = (props: IconProps) => <Icon component={img} {...props} />
export const CheckedIcon = (props: IconProps) => <Icon component={checked} {...props} />
export const ImgOutlineIcon = (props: IconProps) => <Icon component={imgOutline} {...props} />
export const ImgUploadOutlineIcon = (props: IconProps) => <Icon component={imgUploadOutline} {...props} />
export const EyesIcon = (props: IconProps) => <Icon component={eyes} {...props} />
export const EditOutlineIcon = (props: IconProps) => <Icon component={editOutline} {...props} />

export const MajorIcon = (props: IconProps) => <Icon component={major} {...props} />
export const ArchitectureIcon = (props: IconProps) => <Icon component={architecture} {...props} />
export const StructureIcon = (props: IconProps) => <Icon component={structure} {...props} />
export const ElectricIcon = (props: IconProps) => <Icon component={electric} {...props} />
export const WadIcon = (props: IconProps) => <Icon component={wad} {...props} />
export const HvacIcon = (props: IconProps) => <Icon component={hvac} {...props} />
export const SortHandleIcon = (props: IconProps) => <Icon component={sortHandle} {...props} />
export const SortIcon = (props: IconProps) => <Icon component={sort} {...props} />

export const File2Icon = (props: IconProps) => <Icon component={file2} {...props} />
export const File3Icon = (props: IconProps) => <Icon component={file3} {...props} />
export const EditIcon = (props: IconProps) => <Icon component={edit} {...props} />
export const GroupIcon = (props: IconProps) => <Icon component={group} {...props} />
export const FileAddIcon = (props: IconProps) => <Icon component={fileAdd} {...props} />
export const Edit2Icon = (props: IconProps) => <Icon component={edit2} {...props} />
export const RemoveIcon = (props: IconProps) => <Icon component={remove} {...props} />
export const PackupLeftIcon = (props: IconProps) => <Icon component={packupLeft} {...props} />
export const TipsIcon = (props: IconProps) => <Icon component={tips} {...props} />
export const DescIcon = (props: IconProps) => <Icon component={desc} {...props} />
export const ConnectIcon = (props: IconProps) => <Icon component={connect} {...props} />
export const InvalidFileIcon = (props: IconProps) => <Icon component={invalidFile} {...props} />

export const ExpandAllIcon = (props: IconProps) => <Icon component={expandAll} {...props} />
export const ExpandNoneIcon = (props: IconProps) => <Icon component={expandNone} {...props} />
export const File4Icon = (props: IconProps) => <Icon component={file4} {...props} />
export const BookIcon = (props: IconProps) => <Icon component={book} {...props} />
export const AlertIcon = (props: IconProps) => <Icon component={alert} {...props} />
export const BookmarkIcon = (props: IconProps) => <Icon component={bookmark} {...props} />
export const BookmarkFilledIcon = (props: IconProps) => <Icon component={bookmarkFilled} {...props} />
export const LeftArrowIcon = (props: IconProps) => <Icon component={leftArrow} {...props} />
export const RightArrowIcon = (props: IconProps) => <Icon component={rightArrow} {...props} />
export const CategoryIcon = (props: IconProps) => <Icon component={category} {...props} />
export const OrderIcon = (props: IconProps) => <Icon component={order} {...props} />
export const QuestionIcon = (props: IconProps) => <Icon component={question} {...props} />
export const QuestionFilledIcon = (props: IconProps) => <Icon component={questionFilled} {...props} />
export const BackIcon = (props: IconProps) => <Icon component={back} {...props} />
export const ExclamationIcon = (props: IconProps) => <Icon component={exclamation} {...props} />
export const BackLeftIcon = (props: IconProps) => <Icon component={backLeft} {...props} />
export const ClearIcon = (props: IconProps) => <Icon component={clear} {...props} />
export const FavoriteIcon = (props: IconProps) => <Icon component={favorite} {...props} />
export const LikeIcon = (props: IconProps) => <Icon component={like} {...props} />
export const HeartIcon = (props: IconProps) => <Icon component={heart} {...props} />
export const CommentIcon = (props: IconProps) => <Icon component={comment} {...props} />
export const CircleArrowIcon = (props: IconProps) => <Icon component={circleArrow} {...props} />
export const SwitchIcon = (props: IconProps) => <Icon component={switchIcon} {...props} />
export const AlarmIcon = (props: IconProps) => <Icon component={alarm} {...props} />

export const AuditPassIcon = (props: IconProps) => <Icon component={auditPass} {...props} />
export const AuditPauseIcon = (props: IconProps) => <Icon component={auditPause} {...props} />
export const AuditPublishIcon = (props: IconProps) => <Icon component={auditPublish} {...props} />
export const AuditRefuseIcon = (props: IconProps) => <Icon component={auditRefuse} {...props} />
export const AuditRollbackIcon = (props: IconProps) => <Icon component={auditRollback} {...props} />
export const AuditSubmitIcon = (props: IconProps) => <Icon component={auditSubmit} {...props} />
export const AuditUsersIcon = (props: IconProps) => <Icon component={auditUsers} {...props} />

export const ClockIcon = (props: IconProps) => <Icon component={clock} {...props} />
export const FlagIcon = (props: IconProps) => <Icon component={flag} {...props} />
export const FormEditIcon = (props: IconProps) => <Icon component={formEdit} {...props} />
export const RefuseIcon = (props: IconProps) => <Icon component={refuse} {...props} />
export const SealIcon = (props: IconProps) => <Icon component={seal} {...props} />
export const TrashIcon = (props: IconProps) => <Icon component={trash} {...props} />

export const ListIcon = (props: IconProps) => <Icon component={list} {...props} />
export const ListOutlineIcon = (props: IconProps) => <Icon component={listOutline} {...props} />
export const ListBoldIcon = (props: IconProps) => <Icon component={listBold} {...props} />

export const CommentOutlineIcon = (props: IconProps) => <Icon component={commentOutline} {...props} />
export const LikeOutlineIcon = (props: IconProps) => <Icon component={likeOutline} {...props} />
export const HeartOutlineIcon = (props: IconProps) => <Icon component={heartOutline} {...props} />

export const UserFilledIcon = (props: IconProps) => <Icon component={userFilled} {...props} />
export const UserOutlineIcon = (props: IconProps) => <Icon component={userOutline} {...props} />
export const AddUserIcon = (props: IconProps) => <Icon component={addUser} {...props} />
export const CheckOutlineIcon = (props: IconProps) => <Icon component={checkOutline} {...props} />
export const FootIcon = (props: IconProps) => <Icon component={foot} {...props} />

export const HouseIcon = (props: IconProps) => <Icon component={house} {...props} />
export const OrgIcon = (props: IconProps) => <Icon component={org} {...props} />

export const JudgementIcon = (props: IconProps) => <Icon component={judgement} {...props} />
export const CheckboxIcon = (props: IconProps) => <Icon component={checkbox} {...props} />
export const RadioIcon = (props: IconProps) => <Icon component={radio} {...props} />

export const CorrectIcon = (props: IconProps) => <Icon component={correct} {...props} />
export const ErrorIcon = (props: IconProps) => <Icon component={error} {...props} />

export const ExamListIcon = (props: IconProps) => <Icon component={examList} {...props} />
export const Switch2Icon = (props: IconProps) => <Icon component={switch2} {...props} />
export const ErrorCheckbox = (props: IconProps) => <Icon component={errorCheckbox} {...props} />
export const ExamListAddIcon = (props: IconProps) => <Icon component={examListAdd} {...props} />
export const ListAddIcon = (props: IconProps) => <Icon component={listAdd} {...props} />
export const ExamListActiveIcon = (props: IconProps) => <Icon component={examListActive} {...props} />

export const LargeSizeIcon = (props: IconProps) => <Icon component={largeSize} {...props} />
export const MiddleSizeIcon = (props: IconProps) => <Icon component={middleSize} {...props} />
export const MiniSizeIcon = (props: IconProps) => <Icon component={miniSize} {...props} />
export const FullScreenIcon = (props: IconProps) => <Icon component={fullScreen} {...props} />

export const NormalConnectIcon = (props: IconProps) => <Icon component={normalConnect} {...props} />
export const MultipleIcon = (props: IconProps) => <Icon component={multiple} {...props} />

export const FlagFilledIcon = (props: IconProps) => <Icon component={flagFilled} {...props} />
export const NavFilledIcon = (props: IconProps) => <Icon component={navFilled} {...props} />
export const BookFilledIcon = (props: IconProps) => <Icon component={bookFilled} {...props} />

export const EyeFilledIcon = (props: IconProps) => <Icon component={eyeFilled} {...props} />
export const ControlFilledIcon = (props: IconProps) => <Icon component={controlFilled} {...props} />
export const ControlIcon = (props: IconProps) => <Icon component={control} {...props} />
export const DownloadIcon = (props: IconProps) => <Icon component={download} {...props} />
export const ScrollTopIcon = (props: IconProps) => <Icon component={scrollTop} {...props} />

export const AddUserFilledIcon = (props: IconProps) => <Icon component={addUserFilled} {...props} />
export const Edit3Icon = (props: IconProps) => <Icon component={edit3} {...props} />
// 多归属图标
export const MultipleBookIcon = (props: IconProps) => <Icon component={multipleBook} {...props} />
export const BuildingFilledIcon = (props: IconProps) => <Icon component={buildingFilled} {...props} />
export const HomeFilledIcon = (props: IconProps) => <Icon component={homeFilled} {...props} />
export const PersonFilledIcon = (props: IconProps) => <Icon component={personFilled} {...props} />
export const MouseIcon = (props: IconProps) => <Icon component={mouse} {...props} />

